import type { ReplayRequest } from '../model/types';

export const MAX_ATTEMPTS = 3;
export const RETRY_DELAY = 4500;

export const RETRY_STATUS_CODE_LIST = [408, 429, 500, 502, 503, 504];

export const ERROR_MAP = new Map<string, ReplayRequest>([
  [
    'default',
    {
      status: false,
      message: {
        title: 'Ошибка при удалении',
        description: 'Что-то пошло не так. Повторите позже',
      },
    },
  ],
  [
    'network',
    {
      status: false,
      message: {
        title: 'Ошибка сети',
        description: 'Проверьте подключение и попробуйте снова',
      },
    },
  ],
]);
